import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { ContentItemBase, ContractCondition } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled?: boolean;
}

function FieldContractCondition(props: Props): ReactElement {
  const { disabled } = props;

  return (
    <Form.Item
      name="breederContractConditionId"
      label="Condition"
      rules={[{ required: true, message: 'This field is required' }]}
    >
      <Select
        data-testid={testId.fieldContractCondition}
        disabled={disabled}
        placeholder="Select"
      >
        {pricingContent?.contractConditions?.map((c: ContentItemBase) => (
          <Select.Option
            data-testid={testId.fieldContractConditionOption}
            key={c.id}
            value={c.id}
            disabled={c.id === ContractCondition.Increasing}
          >
            {c.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default FieldContractCondition;
